import Autenticacao from './Autenticacao'
import Armazenamento from './Armazenamento'

const gravarDados = (usuario) => {
  Armazenamento.usuario.gravar(usuario)
}

const pegarDados = ({ atualizar = false }) => {
  const cache = Armazenamento.usuario.pegar()
  if (atualizar || !cache || cache.expirado) {
    return Autenticacao.buscar()
      .then(response => {
        if (response.status === 200 && response.data) {
          Armazenamento.usuario.gravar(response.data)
          return Armazenamento.usuario.pegar()
        } else {
          return Promise.reject(response)
        }
      })
  } else {
    return Promise.resolve(cache)
  }
}

export default {
  dados: () => pegarDados({atualizar: false}),
  gravar: gravarDados,
  atualizar: () => pegarDados({atualizar: true})
}



// WEBPACK FOOTER //
// ./src/services/Usuario.js